import React from 'react'
import { Helmet } from 'react-helmet'

interface IProps {
  children: any
  pageTitle?: string
}

const PageLayout: React.FC<IProps> = ({ children, pageTitle }) => {
  return (
    <>
      <div className="flex-1">
        <Helmet>
          <title>{pageTitle ? `${pageTitle} | Rigips` : `Rigips`}</title>
          <html lang="de" />
        </Helmet>
        {children}
      </div>
    </>
  )
}

export default PageLayout
